import "./App.css";
import "antd/dist/antd.css";
import { createContext, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import Login from "pages/Login";

import Missing from "pages/Missing";
import { useDispatch, useSelector } from "react-redux";
import { checkAuth } from "features/auth/userSlice";
import Home from "components/Home/Home";
import MovieDetail from "components/MovieDetail/MovieDetail";
import Auth from "components/Auth";
import JobCardForm from "components/jobcard/JobCardForm";
import CardsTable from "components/MovieListing/CardsTable";
import UpdateJobcard from "components/jobcard/UpdateJobcard";
import "./components/inventory/mobile-inventory.css";
import {
  roleSelector,
} from "features/jobinv/JobCardSlice";
import Reports from "pages/Reports";
import Inventory from "pages/Inventory";
import Slidebar from "components/header/Slidebar";
import Dashboard from "pages/Dashboard";
import CapTable from "components/inventory/CapTable";
import MaterialsStock from "pages/MaterialsStock";
import CreatedCap from "components/inventory/CreatedCap";
import InvenReport from "components/inventory/InvenReport";
import InvRepStockSummary from "pages/InvRepStockSummary";
import InvRepLowStock from "pages/InvRepLowStock";
import InvRepProcurement from "pages/InvRepProcurement";
import InvRepManufacturing from "pages/InvRepManufacturing";
import InvRepAudit from "pages/InvRepAudit";
import InvRepValuation from "pages/InvRepValuation";
import InvRepStockSummaryDatewise from "pages/InvRepStockSummaryDatewise";
import InvRepUsageDatewise from "pages/InvRepUsageDatewise";
import DigitizerJobcards from "pages/DigitizerJobcards";
import SamplingDigitizerJobcards from "pages/SamplingDigitizerJobcards";
import DigitizerJobcardUpdate from "pages/DigitizerJobcardUpdate";
import AdminRoutes from "components/AdminRoute";
import RoleProtectedRoute from "components/RoleProtectedRoute";
import Machine from "pages/Machine";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const AppContext = createContext();

function App() {
  const role = useSelector(roleSelector);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const isDegitizer = (
    role === "degitizer" ||
    (user?.user && (
      user.user.is_degitizer ||
      user.user.roll === "degitizer"
    ))
  );
  // const { JobCards: cards, selectedCard } = useSelector(
  //   (state) => state.JobCard
  // );

  const [currentTablePage, setCurrentTablePage] = useState();

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

 
  return (
    <AppContext.Provider value={{ currentTablePage, setCurrentTablePage }}>
      <div className="App">
        <>
          <BrowserRouter>
            <Slidebar />
            <div style={{ paddingTop: "1px", minHeight: "calc(100vh - 80px)" }}>
              <Routes>
                <Route path="/login" element={<Login />} />

                {/* Dashboard - Admin and Viewer only */}
                <Route
                  path="/"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer"]}>
                        <Dashboard />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Job Card - All roles except store and degitizer */}
                <Route
                  path="/jobcard"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "designer", "cutting", "production", "secendory_process", "embroidary", "accountent", "payment", "packing", "dispatch"]}
                      >
                        <Home />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Inventory - Admin, Viewer, and Store only */}
                <Route
                  path="/inventory"
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "store"]}
                      >
                        <Inventory />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Machine - Admin and Viewer only */}
                <Route
                  path="/machine"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer"]}>
                        <Machine />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Reports - All roles except store and degitizer */}
                <Route
                  path="/reports"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "designer", "cutting", "production", "secendory_process", "embroidary", "accountent", "payment", "packing", "dispatch"]}
                      >
                        <Reports />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Create Job Card - All roles except store and degitizer */}
                <Route
                  path="/create"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "designer", "cutting", "production", "secendory_process", "embroidary", "accountent", "payment", "packing", "dispatch"]}
                      >
                        <JobCardForm />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Job Card Detail - All roles except store and degitizer */}
                <Route
                  path="/detail/:id"
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "designer", "cutting", "production", "secendory_process", "embroidary", "accountent", "payment", "packing", "dispatch"]}
                      >
                        <MovieDetail />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Update Job Card - All roles except store and degitizer */}
                <Route
                  exact
                  path="jobcard/update/:id"
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "designer", "cutting", "production", "secendory_process", "embroidary", "accountent", "payment", "packing", "dispatch"]}
                      >
                        <UpdateJobcard />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Card Table - All roles except store and degitizer */}
                <Route
                  path="/cardtable"
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "designer", "cutting", "production", "secendory_process", "embroidary", "accountent", "payment", "packing", "dispatch"]}
                      >
                        <CardsTable />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Caps - Admin, Viewer, and Store only */}
                <Route
                  path="caps"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "store"]}
                      >
                        <CapTable />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Material - Admin, Viewer, and Store only */}
                <Route
                  path="material"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "store"]}
                      >
                        <MaterialsStock />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Created Cap - Store and Admin only */}
                <Route
                  path="/createdcap"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["store", "admin"]}
                      >
                        <CreatedCap />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Digitizer Job Cards - Degitizer only */}
                <Route
                  path="/digitizer-jobcards"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["degitizer"]}
                      >
                        <DigitizerJobcards />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Sampling Digitizer Job Cards */}
                <Route
                  path="/sampling-digitizer-jobcards"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["sampling_digitizer"]}
                      >
                        <SamplingDigitizerJobcards />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Digitizer Job Card Update - Degitizer only */}
                <Route
                  path="/digitizer-jobcards/:jobcardId"
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["degitizer"]}
                      >
                        <DigitizerJobcardUpdate />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Digitizer Job Card Update (alternative path) - Degitizer only */}
                <Route
                  path="/digitizer-jobcards/:id"
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["degitizer"]}
                      >
                        <DigitizerJobcardUpdate />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Inventory Report - Admin, Viewer, and Store only */}
                <Route
                  path="/invenreport"
                  exact
                  element={
                    <Auth>
                      <RoleProtectedRoute
                        allowedRoles={["admin", "viewer", "store"]}
                      >
                        <InvenReport />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/* Inventory Reports Module - Admin, Viewer, and Store */}
                <Route
                  path="/inventory-reports/stock-summary"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepStockSummary />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />
                <Route
                  path="/inventory-reports/low-stock"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepLowStock />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />
                <Route
                  path="/inventory-reports/procurement"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepProcurement />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />
                <Route
                  path="/inventory-reports/manufacturing-usage"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepManufacturing />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />
                <Route
                  path="/inventory-reports/procurement-audit"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepAudit />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />
                <Route
                  path="/inventory-reports/valuation"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepValuation />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />
                <Route
                  path="/inventory-reports/stock-summary-datewise"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepStockSummaryDatewise />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />
                <Route
                  path="/inventory-reports/usage-datewise"
                  element={
                    <Auth>
                      <RoleProtectedRoute allowedRoles={["admin", "viewer", "store"]}>
                        <InvRepUsageDatewise />
                      </RoleProtectedRoute>
                    </Auth>
                  }
                />

                {/*<Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
<Route path="/about" exact element={<About />} />*/}
                {/* private route example */}
                {/* private route example 
        <Route element={<PrivateRoutes />}>
          <Route path="/about" exact element={<About />} />
        </Route> */}
                <Route path="*" element={<Missing />} />
              </Routes>
            </div>
          </BrowserRouter>
        </>
      </div>
      <ToastContainer />
    </AppContext.Provider>
  );
}

export default App;